import {FaCheck, FaFileExport, FaSave, FaTimes} from 'react-icons/fa';
import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { toast } from "react-toastify";
import { AlertMessage } from "../../utils/alert-message";
import { AgGridReact } from "ag-grid-react";
import { LocalizationAgGrid } from "../../utils/localization-ag-grid";

import TemplateDefault from "../../components/template-default";
import SelectComponent from "../../components/select-component";
import Card from "../../components/card";
import Button from "../../components/button";
import releaseService from '../../services/release-service';
import InputForm from "../../components/input-form";

import "ag-grid-community/styles/ag-grid.css";
import "ag-grid-community/styles/ag-theme-quartz.css";
import Modal from '../../components/modal';
import sshRender from './resources/sshRender';
import ContactsCellRenderer from "../dashboard/components/contacts-cell-renderer";
import ContactsModal from "../dashboard/components/contacts-modal";
import {useQuery} from "@tanstack/react-query";
import ClientModal from "./componentes/client-modal";
import ObservationModal from "./componentes/observation-modal";
import InputText from "../../components/input-text";
import general from "../../utils/general";
import {buildAccentInsensitiveColDef, setAccentInsensitiveQuickFilter} from "../../utils/ag-grid-quick-filter";

const Release = () => {
    const releaseRef = useRef();

    const [project, setProject] = useState();
    const [selectVersions, setSelectVersions] = useState();
    const [release, setRelease] = useState([]);
    const [editedRows, setEditedRows] = useState([]);
    const [isLoading, setIsLoading] = useState(false);
    const [openContactsModal, setOpenContactsModal] = useState(false);
    const [openGenericModal, setOpenGenericModal] = useState(false);
    const [client, setClient] = useState([]);
    const [modalData, setModalData] = useState([{
        principal: "",
        data: "",
        title: ""
    }]);
    const [clientOptions, setClientOptions] = useState([])
    const [clientAuthorization, setclientAuthorizatio] = useState([])
    const [saveClient, setSaveClient] = useState([])
    const [clientValue, setClientValue] = useState([])
    const [observation, setObservation] = useState("")
    const [, setSaveObservation] = useState([])
    const [modalTitle, setmodalTitle] = useState("")

    useEffect(() => {
        addParamsToColumns("release", [
                '',
                'Sim',
                'Não',
            ],
            false);

        addParamsToColumns("status", [
                '',
                'Ativa',
                'Não Atualizar',
                'Em implantação',
            ],
            false);

        addParamsToColumns("client_authorization",
            client,
            true);
    }, [client]);

    useEffect(() => {
        if (project?.value) {
            releaseService.getByRelease(project.value)
                .then(data => {
                    data.forEach(d => {
                        d.contacts = JSON.parse(d.contacts)
                        if (d.solicitation == null) d.solicitation = false
                        if (d.release == null) d.release = "Não"
                        d.date_authorization = d.date_authorization ? d.date_authorization + " 00:00:00" : null
                        return d
                    })
                    setRelease(data);
                });
        }
    }, [project]);

    let i = 0;
    release.forEach(element => {
        if (!element.id) {
            element.id = `${i}-uuid`;
            i++;
        }
    });

    useEffect(() => {
        releaseService.getVersions()
            .then(data => {
                setSelectVersions(data);
            });
    }, []);

    useQuery({
        queryFn: () => releaseService.getProjectUsers()
            .then(data => setClient(data)),
        queryKey: ['client']
    });

    const addParamsToColumns = (field, values, modal) => {
        setColumnDefs((prevColumnDefs) =>
            prevColumnDefs.map((colDef) => {
                if (colDef.field === field) {
                    if (modal){
                        return {
                            ...colDef,
                            cellRendererParams: {
                                ...colDef.cellRendererParams,
                                selectOptions : values
                            }
                        };
                    }else{
                        return {
                            ...colDef,
                            cellEditorParams: { values }
                        };
                    }
                }
                return colDef;
            })
        );
    }

    const contactsRender = (data, value) => {
        setModalData({
            principal: value,
            data: data.contacts,
            title: data.project,
        })
        setOpenContactsModal(true)
    }

    const clientAuthorizationRender = (data, options, value) => {
        const formatedOptions = options.map(({ project_id, ...rest }) => rest);
        setSaveClient(data)
        setClientOptions(formatedOptions)

        setclientAuthorizatio(value)

        setmodalTitle("Cliente que autorizou")

        setOpenGenericModal(true)
    }

    const observationRender = (data, value) => {
        setSaveObservation(data)
        setObservation(value)
        setmodalTitle("Observação")
        setOpenGenericModal(true);
    }

    const [columnDefs, setColumnDefs] = useState([
        {
            field: "project",
            headerName: "Projeto",
            width: 200,
            cellEditor: false
        },
        {
            field: "project_id",
            hide: true,
        },
        {field: "contact_central", headerName: "Contatos", cellRenderer: ContactsCellRenderer,
            cellRendererParams: {
                contactsRender: contactsRender,
            },
            width: 70,
            cellEditor: false
        },
        {
            field: "id_ibge",
            headerName: "ID",
            cellEditor: false,
            cellRenderer: sshRender,
        },
        {
            field: "status",
            headerName: "Status",
            width: 150,
            cellEditor: 'agSelectCellEditor',
            cellEditorParams: { values: [] },
            cellStyle: (params) => {
                if (params.value === "Não Atualizar") {
                    return { color: "red" };
                }
                return null;
            }
        },
        {
            field: "resale",
            headerName: "Revenda",
            width: 250,
            cellEditor: false
        },
        {
            field: "release",
            headerName: "Atualizada",
            width: 100,
            editable: false,
            cellEditor: false
        },
        {
            field: "version",
            headerName: "Versão",
            width: 100,
            cellEditor: 'agTextCellEditor',
            cellEditorParams: { min: 0 }
        },
        {
            field: "date_authorization",
            headerName: "Data Autorização",
            width: 130,
            cellRenderer: ({value}) => general.formatDate(value, "DD/MM/YYYY"),
            cellEditor: "agDateCellEditor",
            valueGetter: (params) => {
                return params.data.date_authorization ? new Date(params.data.date_authorization) : null;
            },
            valueSetter: (params) => {
                if (params.newValue) {
                    params.data.date_authorization = params.newValue.toISOString();
                    return true;
                }
                return false;
            }, editable: true
        },
        {
            field: "client_authorization",
            headerName: "Cliente que Autorizou",
            width: 155,
            cellRenderer: ClientModal,
            cellRendererParams: {
                clientAuthorizationRender: clientAuthorizationRender,
            },
            cellEditor: false
        },
        {
            field: "solicitation", headerName: "Solicitação", width: 100, cellEditor: 'agCheckboxCellEditor',
            cellRenderer: params => {
                return (
                    <span className={"m-auto"}>
                        {
                            params.value ? <FaCheck className={"text-green-600"} /> :
                                <FaTimes className={"text-red-600"} />
                        }
                    </span>
                );
            }
        },
        {
            field: "observation",
            headerName: "Observação",
            width: 340,
            cellRenderer: ObservationModal,
            cellRendererParams: {
                observationRender: observationRender,
            },
            cellEditor: false
        },
    ]);

    const defaultColDef = useMemo(() => buildAccentInsensitiveColDef({
        resizable: true,
        editable: true,
        cellDataType: false,
    }), []);

    const onCellValueChanged = async (event, table) => {
        let updatedData = "";

        if (table === "table") {
            if (event.colDef.field === "version") {
                event.data.release = "Sim";
                releaseRef.current?.api.refreshCells({
                    rowNodes: [event.node],
                    columns: ["release"],
                    force: true
                });
            }

            updatedData = { ...event.data };

            setRelease((prevRelease) =>
                prevRelease.map((row) => row.id === updatedData.id ? updatedData : row)
            );
        } else {
            updatedData = event;
        }

        releaseRef.current?.api.redrawRows();

        setEditedRows((prevEditedRows) => {
            const existingRow = prevEditedRows.find(row => row.id === updatedData.id);
            if (existingRow) {
                return prevEditedRows.map(row => row.id === updatedData.id ? updatedData : row);
            } else {
                return [...prevEditedRows, updatedData];
            }
        });
    }

    const formatDateToSave = (date) => {
        if (date) {
            if (typeof date === 'object') {
                return date.toJSON().split('T')[0];
            }

            return date.split(" ")[0];
        }

        return null;
    }

    const save = () => {
        setIsLoading(true);

        editedRows.forEach(p => {
            p.date_authorization = formatDateToSave(p.date_authorization);

            if (clientValue){
                p.client_authorization = clientValue.value;
                p.client_authorization_login = clientValue.login;
            }
            if (observation){
                p.observation = observation
            }
        });

        releaseService.saveBatch({ data: editedRows, release_version: project?.value })
            .then(({ data }) => {
                data.forEach(d => {
                    d.contacts = JSON.parse(d.contacts)
                    if (d.solicitation == null) d.solicitation = false
                    if (d.release == null) d.release = "Não"
                    d.date_authorization = d.date_authorization ? d.date_authorization + " 00:00:00" : null
                    return d
                })
                setRelease(data);
                setEditedRows([]);
                setclientAuthorizatio([])
                setClientValue([])
                setObservation("")
                setOpenGenericModal(false)
                toast.success("Salvo com sucesso.")
            })
            .catch(error => {
                const { data: { message } } = error.response;
                toast.error(AlertMessage[message] ?? "Não foi possível salvar");
            })
            .finally(() => setIsLoading(false))
    }

    const onFilterTextBoxChanged = useCallback(({ target }) => {
        setAccentInsensitiveQuickFilter(releaseRef, target.value);
    }, []);

    const handleSelect = (id, value) => {
        setSaveClient(prev => ({...prev, [id]: value}))
        onCellValueChanged(saveClient, "client")
    };

    const handleText = (id, value) => {
        setObservation(value);

        setSaveObservation(prev => {
            const updated = { ...prev, [id]: value };
            onCellValueChanged(updated, "observation");
            return updated;
        });
    };

    let modalInput;
    if (modalTitle === "Cliente que autorizou"){
        modalInput = <SelectComponent
            col="col-span-3"
            instanceId="client_authorization"
            label="Cliente"
            options={clientOptions}
            value={clientAuthorization}
            name="client_authorization"
            onChange={(value) => {
                setclientAuthorizatio(value)
                setClientValue(value)
                handleSelect("client_authorization", value?.label)
            }}
        />;
    }else{
        modalInput = <InputText
            id="observation" name="info" value={observation}
            onChange={({target: {value}}) => handleText("observation", value)}
            label="Observação" col="col-span-12"
        />
    }

    const exportRelease = () => {
        const newArray = release.map(data => {
            const text = client.filter(opt => opt.value === data.client_authorization)

            return({
                    "Projeto": data.project,
                    "ID": data.id_ibge,
                    "Status": data.status,
                    "Revenda": data.resale,
                    "Atualizada": data.release,
                    "Versão": data.version,
                    "Data autorização": data.date_authorization,
                    "Cliente que autorizou": text[0]?.label,
                    "Observação": data.observation
                })
            }
        );

        general.exportCsv(newArray);
    }

    return (
        <TemplateDefault title="Atualização" isLoading={isLoading}>
            <Card>
                <div className="flex flex-col lg:grid grid-cols-1 gap-x-6 gap-y-4 lg:grid-cols-12">
                    <div className="col-span-3 text-gray-900">
                        <SelectComponent
                            instanceId="version"
                            label="Versão"
                            options={selectVersions}
                            value={project}
                            onChange={(value) => {
                                setProject(value)
                                setEditedRows([])
                            }}
                        />
                    </div>

                    {
                        project &&
                        <>
                            <div className={"col-span-9 flex gap-4"}>
                                <InputForm id="search" col="w-full" label="Pesquisar" type="search" onChange={onFilterTextBoxChanged} />
                                <Button target="success" onClick={exportRelease}>
                                    <FaFileExport />
                                </Button>
                            </div>
                        </>
                    }
                </div>

                <div className={"ag-theme-quartz grid col-span-12 mt-4"} style={{ height: "calc(100vh - 203px)" }}>
                    <AgGridReact
                        ref={releaseRef}
                        rowHeight={32}
                        rowData={release}
                        columnDefs={columnDefs}
                        defaultColDef={defaultColDef}
                        animateRows={false}
                        suppressRowClickSelection={true}
                        gridOptions={{ localeText: LocalizationAgGrid }}
                        singleClickEdit={true}
                        onCellValueChanged={(event) => onCellValueChanged(event, "table")}
                        stopEditingWhenCellsLoseFocus={true}
                        // getRowClass={(params) => {
                        //     return params.data.status === 'Não Atualizar' ? 'custom-natt-row' : '';
                        // }}
                        // className="release-table"
                    />
                </div>

                {
                    project &&
                    <div className="col-span-12 text-gray-900 mt-3">
                        <div className="flex justify-end gap-3">
                            <Button target={"success"} onClick={() => save("table")}>
                                <FaSave /> Salvar
                            </Button>
                        </div>
                    </div>
                }
            </Card>

            <Modal isOpen={openGenericModal} onClose={() => {
                setOpenGenericModal(false)
                setclientAuthorizatio([])
                }} title={modalTitle} overflow={true} className={modalTitle === "Observação" ? "w-8/12" : "w-6/12"}>
                <div className="p-3">
                    {modalInput}
                </div>
                <div className="flex justify-end gap-2 px-3 py-3 border-t border-gray-300 bg-[#F2F2F2] rounded-b-lg">
                    <div className="flex justify-end gap-3">
                        <Button onClick={() => setOpenGenericModal(false)}>Fechar</Button>
                        <Button target="primary" onClick={() => save("client")}>
                             Salvar
                        </Button>
                    </div>
                </div>
            </Modal>

            <ContactsModal open={openContactsModal} set={setOpenContactsModal} modalData={modalData}/>

        </TemplateDefault>
    );
}

export default Release;
